import React, { FunctionComponent, useState } from 'react'
import { FiCalendar } from 'react-icons/fi'
import Dialog from '@material-ui/core/Dialog'
import moment from 'moment'

import '../styles/Item.scss'
import { CalendarData } from '../utils/SearchItem'
import Icon from './Icon'
import { capitalizeFirstLetter } from '../utils/helper'
import MatchingTerms from './MatchingTerms'

const CalendarItem: FunctionComponent<CalendarData> = (props) => {
  const [open, toggleOpen] = useState(false)

  const renderPopup = () => {
    const date = moment(new Date(props.date)).format('h:mm A • ddd MMM D, YYYY')
    const invitees = props.invitees.split(', ')

    return (
      <Dialog open={open} onClose={() => toggleOpen(false)}>
        <div className='Item-popup'>
          <div className='Item-popup-header'>
            <Icon icon={FiCalendar} backgroundColor='#f8d8d5' />
            <p>{props.title}</p>
          </div>
          <div className='Item-popup-content'>
            <strong>
              <p>Date: </p>
            </strong>
            <p>{date}</p>
            <strong>
              <p>Invitee(s): </p>
            </strong>
            <ul>
              {invitees.map((invitee) => (
                <li>{capitalizeFirstLetter(invitee)}</li>
              ))}
            </ul>
          </div>
          <MatchingTerms
            backgroundColor='#f8d8d5'
            terms={props.matching_terms}
          />
        </div>
      </Dialog>
    )
  }

  return (
    <>
      <div className='Item' onClick={() => toggleOpen(true)}>
        <Icon icon={FiCalendar} backgroundColor='#f8d8d5' />
        <p>{props.title}</p>
      </div>
      {renderPopup()}
    </>
  )
}

export default CalendarItem
